import React from "react";
import { Link } from "react-router-dom";

function Header() {
  return (
    <div>
      {/* Topbar Start */}
      <div
        className="container-fluid px-5 d-none d-lg-block"
        style={{ backgroundColor: "#000000" }}
      >
        <div className="row gx-0">
          <div className="col-lg-8 text-center text-lg-start mb-2 mb-lg-0">
            <div
              className="d-inline-flex align-items-center"
              style={{ height: 45 }}
            >
              <small className="me-3" style={{ color: "#FFD700" }}>
                <i className="fa fa-compass me-2" />
                Rome & Florence, Italy
              </small>
              <small className="me-3" style={{ color: "#FFD700" }}>
                <i className="fa fa-phone-alt me-2" />
                +39 06 123 4567
              </small>
              <small style={{ color: "#FFD700" }}>
                <i className="fa fa-envelope-open me-2" />
                info@viaitaliatours.com
              </small>
            </div>
          </div>
          <div className="col-lg-4 text-center text-lg-end">
            <div
              className="d-inline-flex align-items-center"
              style={{ height: 45 }}
            >
              <a
                className="btn btn-sm btn-sm-square rounded-circle me-2"
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ borderColor: "#FFD700", color: "#87CEEB" }}
              >
                <i className="fab fa-twitter fw-normal" />
              </a>
              <a
                className="btn btn-sm btn-sm-square rounded-circle me-2"
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ borderColor: "#FFD700", color: "#87CEEB" }}
              >
                <i className="fab fa-facebook-f fw-normal" />
              </a>
              <a
                className="btn btn-sm btn-sm-square rounded-circle me-2"
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ borderColor: "#FFD700", color: "#87CEEB" }}
              >
                <i className="fab fa-instagram fw-normal" />
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Topbar End */}

      {/* Navbar & Hero Start */}
      <div
        className="container-fluid position-relative p-0"
        style={{ backgroundColor: "#FFFFFF" }}
      >
        <nav className="navbar navbar-expand-lg navbar-light px-4 px-lg-5 py-3 py-lg-0">
          <Link to="/" className="navbar-brand p-0">
            <h2
              style={{
                margin: 0,
                fontWeight: "bold",
              }}
            >
              <span style={{ color: "#D4AF37" }}>Via Italia</span>
              <span style={{ color: "#000000" }}> Tours</span>
            </h2>
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
          >
            <span className="fa fa-bars" style={{ color: "#000000" }} />
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <div className="navbar-nav ms-auto py-0">
              <Link
                to="/"
                className="nav-item nav-link"
                style={{ color: "#000000", fontWeight: "500" }}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#87CEEB")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "#000000")}
              >
                Home
              </Link>
              <Link
                to="/Contact"
                className="nav-item nav-link"
                style={{ color: "#000000", fontWeight: "500" }}
                onMouseEnter={(e) => (e.currentTarget.style.color = "#87CEEB")}
                onMouseLeave={(e) => (e.currentTarget.style.color = "#000000")}
              >
                Contact
              </Link>
            </div>
            <Link
              to="/Booking"
              className="btn rounded-pill py-2 px-4 ms-lg-3"
              style={{
                backgroundColor: "#FFD700",
                color: "#000000",
                border: "none",
                fontWeight: "600",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#87CEEB";
                e.currentTarget.style.color = "#000000";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#FFD700";
                e.currentTarget.style.color = "#000000";
              }}
            >
              Book a Tour
            </Link>
          </div>
        </nav>
      </div>
      {/* Navbar & Hero End */}
    </div>
  );
}

export default Header;
